module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/assessment_achievements/3_3fc76b8ee57c63a145798c01c03a1c5a.png";